import { withStyles } from "@material-ui/core";
import React from "react";
import { observer, inject } from "mobx-react";
import ArrowDropDown from "@material-ui/icons/KeyboardArrowDown";
import Select , {components} from "react-select";
import { WithPickupsGridFilterHOC } from "./index";
import StyledTooltip from "../../../StyledTooltip";

const styles = (theme) => ({
  pickupsSelectFilter: {
    "& .select__control": {
      minWidth: 136,
      backgroundColor: "transparent",
      minHeight: 28,
      maxHeight: 28,
      boxSizing: "border-box",
      borderRadius: 2,
      fontSize: theme.textFontSize,
      border: `1px solid ${theme.iconColor}`,
      cursor: "pointer",
      "&:hover,&.select__control--is-focused": {
        boxShadow: "none",
        border: `1px solid ${theme.iconColor}`,
      },
      "& .select__value-container": {
        height: 24,
        color: theme.TextColor,
      },
      "& .select__single-value": {
        color: "inherit",
      },
      "& .select__placeholder": {
        top: "50%",
      },
      "& .select__input": {
        color: theme.TextColor,
      },
      "& .select__indicators": {
        height: 24,
        "& .select__indicator": {
          padding: 5,
          height: 24,
        },
        "& .select__indicator-separator": {
          height: 24,
          margin: 0,
          display: "none",
        },
      },
    },
    "& .select__menu": {
      margin: 0,
      maxHeight: 140,
      border: `1px solid ${theme.iconColor}`,
      borderRadius: "0 0 2px 2px",
      borderTop: "none",
      "& .select__menu-list": {
        maxHeight: 139,
        borderRadius: 2,
        fontSize: theme.textFontSize,
        backgroundColor: theme.ModalBGColor,
        color: theme.TextColor,
      },
      "& .select__option--is-focused": {
        backgroundColor: theme.HighlightColor,
        cursor: "pointer",
      },
      "& .select__option--is-selected": {
        backgroundColor: theme.HeaderSelectedText,
      },
    },
  },
  pickupsFilterDropdownIconStyle: {
    cursor: "pointer",
    color: theme.iconColor,
    marginRight: 4,
    marginTop: 3,
    fontSize: 18,
  },
});

@inject("DispatchStore")
@observer
class PickupsGridFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPickupType: null,
    };
  }

  componentDidMount() {
    const { DispatchStore } = this.props;
    const defaultFilter = DispatchStore.pickupsFilter
      ? DispatchStore.pickupsFilter
      : this.props.defaultFilter;
    !DispatchStore.pickupsFilter &&
      DispatchStore.updatePickupsFilter(defaultFilter);
    this.filterPickups(true)(
      this.props.options.find((option) => option.value === defaultFilter.value)
    );
    this.props.stack.layoutManager.eventHub.on("pickupsPanelfilterchanged", this.handleFilterChanged);
  }
  componentWillUnmount() {
    this.props.stack.layoutManager.eventHub.off("pickupsPanelfilterchanged", this.handleFilterChanged);
  }

  handleFilterChanged = (option) => {
    this.filterPickups()(option);
  };

  filterPickups = (isPickupFilterMounted=false) => (option) => {
    if (this.state.selectedPickupType?.value !== option.value) {
      this.props.stack.layoutManager.eventHub.emit(
        `${this.props.headerId}_selectFilterSelected`,
        {option, isPickupFilterMounted}
      );
      this.setState({
        selectedPickupType: option,
      });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Select
        value={this.state.selectedPickupType}
        onChange={this.filterPickups()}
        options={this.props.options}
        classNamePrefix={'select'}
        className={classes.pickupsSelectFilter}
        menuPlacement="auto"
        menuPosition="absolute"
        closeMenuOnSelect
        components={{
          DropdownIndicator: (props) => (
            <ArrowDropDown
              {...props.innerProps}
              className={classes.pickupsFilterDropdownIconStyle}
            />
          ),
          Option: (props) => (
            <components.Option {...props}>
              <StyledTooltip title={props.data.title ?? ""}>
                <div>{props.data.label}</div>
              </StyledTooltip>
            </components.Option>
          )
        }}
      />
    );
  }
}

export default WithPickupsGridFilterHOC(withStyles(styles)(PickupsGridFilter));
